import axios from "axios";
import { ElMessage } from "element-plus";

// 控制多个请求报错时错误提示框始终只显示一个
export const uniqueMessageBox = (function () {
  const arr: any = [];
  return function (msg: any) {
    if (!arr.length) {
      arr.push(msg);
      ElMessage({
        showClose: true,
        message: msg,
        type: "error",
        duration: 2000,
        onClose: () => {
          arr.shift();
        },
      });
    }
  };
})();

// 线上环境，baseURL加上/api
const baseURL = process.env.NODE_ENV === 'production' ? '/website' : '/website1'

// 创建一个请求重试机制
const axiosRetry = async (config: any, retries = 3, delay = 300) => {
  try {
    const instance = axios.create({
      baseURL,
      withCredentials: true,
      timeout: 15000,
    });
    return await instance(config);
  } catch (error: any) {
    // 如果是取消请求或者已经没有重试次数，则抛出错误
    if (axios.isCancel(error) || retries <= 0) {
      throw error;
    }
    
    // 等待一段时间后重试
    await new Promise(resolve => setTimeout(resolve, delay));
    console.log(`请求重试: ${config.url}, 剩余重试次数: ${retries-1}`);
    return axiosRetry(config, retries - 1, delay * 2);
  }
};

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  function (config) {
    // if(process.env.NODE_ENV === 'production') {
    //   config.url = config.url?.replace('http://', 'https://');
    // }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response.data);
  },
  async function (error) {
    // 如果是取消请求，尝试重新发起请求
    if (axios.isCancel(error) || 
        (error.message && (error.message.includes('cancel') || error.message.includes('abort')))) {
      try {
        // 使用重试机制重新发起请求
        const response = await axiosRetry(error.config);
        return Promise.resolve(response.data);
      } catch (retryError: any) {
        // 如果重试也失败了，且不是取消请求，才显示错误提示
        if (!axios.isCancel(retryError) && 
            (!retryError.message || 
             (!retryError.message.includes('cancel') && !retryError.message.includes('abort')))) {
          uniqueMessageBox("网络错误");
        }
        return Promise.reject(retryError);
      }
    }
    
    // 对于其他类型的错误，显示错误提示
    uniqueMessageBox("网络错误");
    return Promise.reject(error);
  }
);

export default axiosInstance;